type FormatMoneyOptions = Intl.NumberFormatOptions & {
  stripZeroCents?: boolean
  inCents?: boolean
}

export function formatMoney(
  amount: number | string,
  {
    currency = 'EUR',
    stripZeroCents = true,
    inCents = false,
    ...options
  }: FormatMoneyOptions = {},
) {
  amount = (Number.isNaN(+amount) ? 0 : +amount) / (inCents ? 100 : 1)

  const text = new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency,
    ...options,
  }).format(amount)

  if (stripZeroCents) {
    return text.replace('.00', '')
  }
  return text
}

export const MONEY_INPUT_PLACEHOLDER = '€0.00'
